import { node, icon } from "~/util/dom";
import Report from "~/report/index";
import { reportWaitForLogin, reportAnalytics } from "~/report/util";
import { getAddPlaceOptions } from "~/report/options";
import { _ } from "~/i18n";
import { store } from "~/state/store";

export function makeNoSearchResultsReport(): HTMLDivElement {
	const container = node("div", { className: "report-defect-nsr" });
	const desc = node("p", { className: "report-defect-nsrInfo", textContent: _("report.noResults") });
	const descResp = node("p", { className: "report-defect-nsrInfo responsive", textContent: _("report.noResultsResponsive") });
	const addPlaceBtn = node("button", { type: "button", className: "report-defect-nsrButton" });

	addPlaceBtn.setAttribute("data-log-ignore", "true");
	addPlaceBtn.append(
		icon("report-add-location"),
		node("span", { className: "caption", textContent: _("report.addPlace2") }),
	);
	container.append(
		desc,
		descResp,
		addPlaceBtn,
	);
	addPlaceBtn.addEventListener("click", async () => {
		reportAnalytics({
			text: "Přidat chybějící místo",
			origin: "search",
			type: "missingPlace",
		});

		await reportWaitForLogin();

		const curState = store.getState();
		const report = new Report(getAddPlaceOptions({
			values: {},
			analytics: {
				type: "missingPlace",
				origin: "search",
			},
			project: "search",
			coords: {
				lon: curState.map.longitude,
				lat: curState.map.latitude,
			},
		}));

		report.open();
	});

	return container;
}

export function makeSearchReport(): HTMLDivElement {
	const container = node("div", { className: "report-defect-searchReport" });

	container.innerHTML = _("report.searchReport", {
		linkStart: `<a href="#">`,
		linkEnd: "</a>",
	});

	const link = container.querySelector("a");

	if (link) {
		link.setAttribute("data-log-ignore", "true");
		link.addEventListener("click", async event => {
			event.preventDefault();
			event.stopPropagation();
			reportAnalytics({
				text: "nám jej pomůžete přidat",
				origin: "search",
				type: "missingPlace",
			});

			await reportWaitForLogin();

			const curState = store.getState();
			const report = new Report(getAddPlaceOptions({
				values: {},
				analytics: {
					type: "missingPlace",
					origin: "search",
				},
				project: "search",
				coords: {
					lon: curState.map.longitude,
					lat: curState.map.latitude,
				},
			}));

			report.open();
		});
	}

	return container;
}
